import { useCallback, useEffect, useRef, useState } from 'react';

import { readScreenerQuestionBanks } from '@api/instant_survey';
import type { ScreenerQuestionBank } from '@api/instant_survey/types';

export const useScreenerQuestionBanks = () => {
  const [data, setData] = useState<ScreenerQuestionBank[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const requestControllerRef = useRef<AbortController | null>(null);

  const fetchBanks = useCallback(async () => {
    requestControllerRef.current?.abort();
    const controller = new AbortController();
    requestControllerRef.current = controller;

    setIsLoading(true);
    setIsError(false);

    try {
      const { results } = await readScreenerQuestionBanks({
        ordering: 'id',
        signal: controller.signal,
      });

      setData(results);
    } catch {
      if (!controller.signal.aborted) setIsError(true);
    } finally {
      if (!controller.signal.aborted) setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBanks();

    return () => requestControllerRef.current?.abort();
  }, [fetchBanks]);

  return {
    data,
    isError,
    isLoading,
    refetch: fetchBanks,
  };
};
